const TITLE_CASE_SMALL_WORDS = new Set([
  'a',
  'an',
  'and',
  'as',
  'at',
  'but',
  'by',
  'for',
  'in',
  'nor',
  'of',
  'on',
  'or',
  'per',
  'the',
  'to',
  'vs',
  'with',
]);

/**
 * Title-cases feed display text using standard small-word rules: lowercase
 * articles, conjunctions, and short prepositions except as the first or last
 * word. Whitespace and punctuation between words (e.g. "+") are preserved.
 */
export function formatHomeFeedTitleCase(value: string): string {
  const parts = value.split(/(\s+)/);
  const wordParts = parts.filter((part) => part.trim().length > 0);
  let wordIndex = 0;

  return parts
    .map((part) => {
      if (part.trim().length === 0) return part;

      const normalizedWord = part.toLowerCase();
      const isFirst = wordIndex === 0;
      const isLast = wordIndex === wordParts.length - 1;
      wordIndex += 1;

      if (!isFirst && !isLast && TITLE_CASE_SMALL_WORDS.has(normalizedWord)) {
        return normalizedWord;
      }

      return capitalizeWord(part);
    })
    .join('');
}

function capitalizeWord(word: string): string {
  if (word.length === 0) return word;

  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
